import { PropsWithChildren } from 'react'
import { RadioGroup } from '@headlessui/react'
import { useController } from 'react-hook-form'

type RadioCardGroupProps = PropsWithChildren<{
  name: string
  control: any
  disabled?: boolean
}>

export function RadioCardGroup({ name, control, children, disabled = false }: RadioCardGroupProps) {
  const { field: { value, onChange }} = useController({ name, control })
  
  return (
    <RadioGroup
      value={value} 
      onChange={onChange}
      className="w-full"
      disabled={disabled}
    >
      <div className="flex w-full bg-white group">
        {children}
      </div>
    </RadioGroup>
  )
}